import styled from 'styled-components';

import type {StyledTrustPilotContainerProps} from './typings';

export const StyledTrustPilotContainer = styled.div<StyledTrustPilotContainerProps>`
  width: 100%;
`;
